import React from 'react';

import { useDispatch } from 'react-redux';

import { Col } from 'reaxl';
import { MyWalletInputCard } from 'reaxl-wallet';

import paymentsDuck from '@/ducks/paymentsDuck.js';
import srpReuseActiveStateDuck from '@/ducks/srp/srpReuseActiveStateDuck.js';

import PaymentCalculationFetcher from '@/fetchers/PaymentCalculationFetcher';

import useCustomContent from '@/hooks/useCustomContent';
import useSrpNavigation from '@/hooks/useSrpNavigation';

function WalletInputCardContainer() {
    const dispatch = useDispatch();
    const navigateToSrp = useSrpNavigation();

    // not show the card if NFC and on the national URL SRP page
    const { isEnableCustomContent } = useCustomContent();

    const shouldRenderWalletInputCard = !isEnableCustomContent;

    const handleSearchAvailVehiclesClick = async (maxPrice) => {
        const newFiltersValues = {
            maxPrice,
        };

        await dispatch(srpReuseActiveStateDuck.creators.setFalse());
        navigateToSrp({
            filtersValues: newFiltersValues,
            isNewSearch: true,
            resetPagination: true,
        });
    };

    return shouldRenderWalletInputCard && (
        <Col
            className="display-flex"
            xs={12}
            sm={6}
            md={4}
        >
            <MyWalletInputCard
                paymentsDuck={paymentsDuck}
                onSearchAvailVehiclesClick={handleSearchAvailVehiclesClick}
                paymentCalculationFetcher={PaymentCalculationFetcher}
            />
        </Col>
    );
}

export default WalletInputCardContainer;
